interface LightboardsIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const LightboardsIcon = (props: LightboardsIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <g>
          <path
            style={{ fill: fillColor }}
            d="M27.4,6.7H12.6c-0.6,0-1.1,0.5-1.1,1.1v20.8c0,0.6,0.5,1.1,1.1,1.1h1.6v3.8h1.2v-3.8h9.2v3.7h1.2v-3.7h1.8
                  c0.6,0,1.1-0.5,1.1-1.1V7.7C28.5,7.1,28,6.7,27.4,6.7z M27.3,28.4H12.7V7.8h14.6V28.4z"
          />
          <path
            style={{ fill: fillColor }}
            d="M20.1,24.9h-0.2c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h0.2c0.3,0,0.5-0.2,0.5-0.5S20.4,24.9,20.1,24.9
                  L20.1,24.9z"
          />
          <path
            style={{ fill: fillColor }}
            d="M18,20.5V21c0,0.3,0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5v-0.5c1.7-0.9,2.8-2.7,2.8-4.6
                  c0-2.7-2.1-5-4.8-5.1c-2.7,0.1-4.8,2.4-4.8,5.1C15.2,17.8,16.3,19.6,18,20.5z M20,11.8c2.2,0.1,3.9,1.9,3.8,4.1
                  c0,1.7-1,3.3-2.6,3.9L21,19.8v0.7h-2v-0.7l-0.2-0.1c-1.6-0.6-2.7-2.2-2.6-3.9C16.1,13.7,17.8,11.9,20,11.8z"
          />
          <path
            style={{ fill: fillColor }}
            d="M20.6,23.4h-1.3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h1.3c0.3,0,0.5-0.2,0.5-0.5
                  C21.1,23.6,20.9,23.4,20.6,23.4z"
          />
          <path
            style={{ fill: fillColor }}
            d="M21.1,22h-2.3c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h2.3c0.3,0,0.5-0.2,0.5-0.5
                  C21.7,22.2,21.4,21.9,21.1,22z"
          />
        </g>
      </g>
    </svg>
  )
}

export default LightboardsIcon
